import { ArrowDownward, ArrowUpward } from '@mui/icons-material';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { IconButton, List, ListItem, ListItemText } from '@mui/material';
import React, { useState } from 'react';
import { MBWStageDownload, StageComponentInterface } from '../../../../../interfaces/pagebuilder';
import { VyImage } from '../../../../common/VyImage';
import VyModal from '../../../../common/VyModal';
import MBWDownloadForm from './MBWDownloadForm';

interface MBWDownloadSettingsProps {
  component: StageComponentInterface;
  onChange: (c: StageComponentInterface) => void;
}

const MBWDownloadSettings = ({ component, onChange }: MBWDownloadSettingsProps) => {
  const [currentDownload, setCurrentDownload] = useState<MBWStageDownload | undefined>();

  function handleDownloadDelete(download: MBWStageDownload) {
    console.log('Delete d', download);
    if (!download.file) return;
    const _component = { ...component };

    const _downloads = _component.downloads ? [..._component.downloads] : [];
    const _downloadsWithoutDeleted = _downloads.filter((d) => d.file !== download.file);
    const _sortedDownloads = _downloadsWithoutDeleted.sort((a, b) => a.sortIndex - b.sortIndex);
    const _sortedDownloadsWithNewIndex = _sortedDownloads.map((d, i) => ({ ...d, sortIndex: i }));

    _component.downloads = _sortedDownloadsWithNewIndex;
    onChange(_component);
  }

  function reorder(startIndex: number, endIndex: number) {
    let result = Array.from(component.downloads || []);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    result = result.map((m, index) => {
      return { ...m, sortIndex: index };
    });
    result.sort((a, b) => a.sortIndex - b.sortIndex);
    onChange({ ...component, downloads: result });
  }

  return (
    <div className="flex flex-col w-full">
      <MBWDownloadForm component={component} onChange={onChange} />
      <List dense>
        {component?.downloads &&
          [...component?.downloads]
            .sort((a, b) => a.sortIndex - b.sortIndex)
            .map((d, index) => (
              <ListItem key={d.file} className="flex">
                <VyImage id={d.thumbnail} returnPlaceholder={true} className="h-8 w-8" />
                <ListItemText primary={d.title} className="truncate pl-2 pr-2 flex-1" />
                <div className="flex">
                  {!!component?.downloads?.length && (
                    <>
                      <IconButton
                        disabled={component?.downloads?.length < 2 || index === component?.downloads?.length - 1}
                        onClick={() => reorder(index, index + 1)}>
                        <ArrowDownward />
                      </IconButton>
                      <IconButton disabled={component?.downloads?.length < 2 || index === 0} onClick={() => reorder(index, index - 1)}>
                        <ArrowUpward />
                      </IconButton>
                    </>
                  )}
                  <IconButton onClick={() => setCurrentDownload(d)} edge="end" aria-label="edit" size="large">
                    <EditIcon />
                  </IconButton>
                  <IconButton onClick={() => handleDownloadDelete(d)} edge="end" aria-label="delete" size="large">
                    <DeleteIcon />
                  </IconButton>
                </div>
              </ListItem>
            ))}
      </List>
      {currentDownload && (
        <VyModal open={!!currentDownload} onClose={() => setCurrentDownload(undefined)}>
          {(onClose) => <MBWDownloadForm component={component} onChange={onChange} onSubmit={onClose} currentDownload={currentDownload} />}
        </VyModal>
      )}
    </div>
  );
};

export default MBWDownloadSettings;
